import React, { useState } from 'react'
import { LinkWithIcon } from '../../application'
import * as validator from '../../application/validator'
import getText from '../strings'
import WizardButtons from './WizardButtons'
import Field from './Field'
import styled from 'react-emotion'

const Wrapper = styled('div')``

const FlexRow = styled('div')`
  display: flex;
  justify-content: space-between;
  >div {
    width: calc(50% - 10px);
  }
  @media (max-width: 992px) {
    flex-direction: column;
    >div {
      width: 100%;
    }
  }
`

const Actions = styled('div')`
  a {
    margin-right: 10px;
  }
`
const BookingNumbers = ({ bookingNumbers, add, remove, change }) => (
  <div>
    {bookingNumbers.length > 0 && <label><strong>{getText('wizard', 'step1', 'bookingNumber')}</strong></label>}
    {bookingNumbers.map((bookingNumber, index) =>
      <FlexRow key={`${bookingNumber}-${index}`}>
        <Field
          validations={[validator.required]}
          value={bookingNumber}
          editMode={true}
          onBlur={(value) => change(bookingNumber, value)}
          placeholder={getText('wizard', 'step1', 'bookingNumber')} />
        <LinkWithIcon icon="minus-circled" text={getText('wizard', 'step1', 'removeBookingNumber')} action={() => remove(index)} />
      </FlexRow>
    )}
    <Actions>
      <LinkWithIcon icon="plus--circled" text={getText('wizard', 'step1', 'addBookingNumber')} action={add} />
    </Actions>
  </div>
)

export default ({ caseType, onNextClick, initialValues }) => {
  const [values, setValues] = useState(initialValues)

  const handleChangeFirstName = (firstName) => {
    setValues({ ...values, firstName })
  }

  const handleChangeLastName = (lastName) => {
    setValues({ ...values, lastName })
  }

  const handleChangeEmail = (email) => {
    setValues({ ...values, email })
  }

  const handleChangeMobile = (mobile) => {
    setValues({ ...values, mobile })
  }

  const handleChangeBirthDate = (birthDate) => {
    setValues({ ...values, birthDate })
  }

  const handleAddBooking = () => {
    setValues({ ...values, bookingNumbers: values.bookingNumbers.concat("") })
  }

  const handleRemoveBooking = (index) => {
    const bookingNumbers = values.bookingNumbers
    bookingNumbers.splice(index, 1)
    setValues({ ...values, bookingNumbers })
  }

  const handleChangeBooking = (bookingNumber, value) => {
    const index = values.bookingNumbers.indexOf(bookingNumber)
    const bookingNumbers = values.bookingNumbers
    bookingNumbers[index] = value
    setValues({ ...values, bookingNumbers })
  }

  const invalid = validator.required(values.firstName)
    || validator.required(values.lastName)
    || validator.required(values.mobile)
    || validator.email(values.email)
    || validator.date(values.birthDate)
    || values.bookingNumbers.map(b => validator.required(b)).filter(b => !!b)[0]

  return (
    <Wrapper>
      <h4>1.&nbsp;{getText('wizard', 'step1', 'yourDetails')}</h4>
      <FlexRow>
        <Field id="firstName" value={values.firstName} onChange={handleChangeFirstName} placeholder={getText('wizard', 'step1', 'firstName')} maxLength="100" validations={[validator.required]} label={getText('wizard', 'step1', 'firstName')} editMode={true} />
        <Field id="lastName" value={values.lastName} onChange={handleChangeLastName} placeholder={getText('wizard', 'step1', 'lastName')} maxLength="100" validations={[validator.required]} label={getText('wizard', 'step1', 'lastName')} editMode={true} />
      </FlexRow>
      <FlexRow>
        <Field id="email" value={values.email} onChange={handleChangeEmail} maxLength="200" placeholder={getText('wizard', 'step1', 'email')} validations={[validator.email]} label={getText('wizard', 'step1', 'email')} editMode={true} />
        <Field name="mobile" value={values.mobile} onChange={handleChangeMobile} maxLength="20" placeholder={getText('wizard', 'step1', 'mobilePhone')} validations={[validator.required]} label={getText('wizard', 'step1', 'mobilePhone')} editMode={true} />
      </FlexRow>
      <FlexRow>
        <Field name="birthDate" value={values.birthDate} onChange={handleChangeBirthDate} maxLength="10" placeholder={getText('wizard', 'step1', 'birthDatePattern')} validations={[validator.required, validator.date]} label={getText('wizard', 'step1', 'birthDate')} editMode={true} />
      </FlexRow>
      <h4>2.&nbsp;{getText('wizard', 'step1', 'yourTripsWithTui')}</h4>
      <p>{caseType === 'forgetme' ? getText('wizard', 'step1', 'yourTripsWithTuiInformation') : getText('wizard', 'step1', 'yourTripsWithTuiInformationNotDelete')}</p>
      <BookingNumbers
        bookingNumbers={values.bookingNumbers}
        add={handleAddBooking}
        remove={handleRemoveBooking}
        change={handleChangeBooking} />
      <WizardButtons>
        <button
          className="btn btn-function"
          type="button"
          disabled={invalid}
          onClick={() => onNextClick(values)}>
          {getText('wizard', 'step1', 'next')}
        </button>
      </WizardButtons>
    </Wrapper>
  )
}
